import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { SmartCitiesHelper, CityProfile, CityProfileIndicatorsHelper, CityIndicatorScoreHelper } from 'app/shared/objects/cities';

@Injectable()
export class CityIndicatorsService {

  constructor(private http: HttpClient) { }

  getCityProfile(id: string): Promise<CityProfileIndicatorsHelper>  {
        return this.http.get(environment.apiURL + '/dashboard/cityIndicatorsProfile/' + id)
        .toPromise()
        .then(response => {
            return response as CityProfileIndicatorsHelper;
        })
        .catch(error => {
            return null;
        });
    }
}

export class MethodologyHelper {
    areaId: string;
    areaName: string;
    areaIcon: string;
    areaBenchmarkCity: SmartCitiesHelper = new SmartCitiesHelper;
    indicatorAmount: Number;
    indicators: Array<MethodologyIndicatorHelper> = [];
}

export class MethodologyIndicatorHelper {
    indicatorId: string;
    indicatorName: string;
    indicatorBenchmarkCity: SmartCitiesHelper = new SmartCitiesHelper;
}
